// Display helpers for area venues (area_places). Pure and presentation-only:
// they group food/drink while retaining explicit mountain amenity categories.

/** Place categories used by the map, bottom sheets and offline list. */
export type PlannerPlaceDisplayCategory = "coffee" | "food" | "apres" | "toilets" | "drinking_water" | "bike_repair" | "shelter" | "parking";
export const PLACE_DISPLAY_LABEL: Record<PlannerPlaceDisplayCategory, string> = {
  coffee: "Coffee", food: "Food and drink", apres: "Apres", toilets: "Toilets",
  drinking_water: "Drinking water", bike_repair: "Bike repair point", shelter: "Shelter", parking: "Parking",
};

/**
 * Collapse a stored `area_places.category` into a display bucket:
 * `cafe` -> coffee; `mountain_restaurant`/`restaurant` -> food;
 * `bar`/`apres` -> apres. Anything unexpected falls back to "food".
 */
export function displayCategoryFor(category: string): PlannerPlaceDisplayCategory {
  switch (category) {
    case "toilets": case "drinking_water": case "bike_repair": case "shelter": case "parking":
      return category;
    case "cafe":
      return "coffee";
    case "bar":
    case "apres":
      return "apres";
    case "mountain_restaurant":
    case "restaurant":
      return "food";
    default:
      return "food";
  }
}

/**
 * Pound-tier label for a Google price level. 1 -> "£", 2 -> "££", 3 -> "£££",
 * 4 -> "££££". 0, null and any out-of-range value return null (no label).
 */
export function priceTierLabel(priceLevel: number | null): string | null {
  if (priceLevel == null) return null;
  if (!Number.isInteger(priceLevel)) return null;
  if (priceLevel < 1 || priceLevel > 4) return null;
  return "£".repeat(priceLevel);
}
